<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs @tab-click="dianji">
        <!-- 系统SMTP发信默认管控策略 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.smtpIp1") }}</span>
          <div class="main maina-a" v-show="this.control_show == 1">
            <p>
              <span class="main_text"> {{ $t("logs.smtpIp4") }}:</span>
              <el-select
                v-model="defaut_pol"
                placeholder="请选择"
                style="width: 150px"
              >
                <el-option
                  v-for="item in defaut_pol_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-button
                @click="save_user_smtp()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.save_a") }}</el-button
              >
              <el-button
                @click="add_user_smtp()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.smtpIp5") }}</el-button
              >
              <el-alert
                :title="this.show_hint1"
                type="warning"
                show-icon
                :closable="false"
                style="flex: 1"
              ></el-alert>
              <!-- 添加各个账号的SMTP发信默认管控策略 -->
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-show="this.control_show == 1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60">
                </el-table-column>
                <el-table-column prop="EMAIL" :label="$t('logs.smtpIp9')">
                   <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.EMAIL"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_EMAIL }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>
                
                <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')">
                </el-table-column>
                 <el-table-column prop="DESCRIPTION" :label="$t('logs.Policy_list7')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="del_edit_user_smtp(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->
                    <el-button
                      @click="add_edit_user_smtp(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加编辑 -->
            <div class="lie lie_add_role" v-show="tanchu">
              <!--  认证控制-->

              <div class="create_information" v-show="this.control_edit == 0">
                {{ $t("logs.smtpIp5") }}
              </div>
              <div class="create_information" v-show="this.control_edit == 1">
                {{ $t("logs.smtpIp5_edit") }}
              </div>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.smtpIp9") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      style="margin: 10px 0"
                      :autosize="{ minRows: 6, maxRows: 10 }"
                      placeholder="一行一个,也可以用逗号隔开"
                      v-model="email"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 类型 -->

                    {{ $t("logs.smtpIp6") }} :
                  </div>
                  <div class="block block1">
                    <el-select v-model="type" placeholder="请选择">
                      <el-option
                        v-for="item in type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 备注说明 -->
                  <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    

                    {{ $t("logs.Policy_list7") }} :
                  </div>
                  <div class="block block1">
                   <el-input
  placeholder="请输入内容"
  v-model="description"
  clearable>
</el-input>
                  </div>
                </div>
                <div class="find1">
                <div class="find-text" style="padding-right: 12px"></div>
                <div class="block block1">
                  <el-button type="primary" @click="add_save_user_smtp" :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("tab.save")
                  }}</el-button>
                  <el-button type="danger" @click="off_save_user_smtp">{{
                    $t("tab.cancel")
                  }}</el-button>
                </div>
              </div>
              </div>
              
            </div>
          </div>
        </el-tab-pane>
        <!-- 系统允许SMTP发信IP范围 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.smtpIp2") }}</span>
          <div class="main maina-a" v-show="this.system_ip_show==1">
            <p>
              <el-button
                @click="tan_ip()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.smtpIp7") }}</el-button
              >
             
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-show="this.system_ip_show==1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column prop="IPADDR" :label="$t('logs.network1_a5')">
                     <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.IPADDR"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_IPADDR }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>
 <el-table-column prop="DESCRIPTION" :label="$t('logs.Policy_list7')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="del_ip(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->
                    <el-button
                      @click="edit_user_smtp_ip(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="lie lie_add_role"
              v-show="tanchu"
             
            >
          
               <div class="create_information" v-show="this.system_ip_edit==0">
                {{ $t("logs.smtpIp7") }}
              </div>
              <div class="create_information" v-show="this.system_ip_edit == 1">
                {{ $t("logs.smtpIp7_edit") }}
              </div>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_ip1") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      style="margin: 10px 0"
                      :autosize="{ minRows: 6, maxRows: 10 }"
                      placeholder="一行一个,也可以用逗号隔开"
                      v-model="ipaddr"
                    >
                    </el-input>
                  </div>
                </div>
                  <!-- 备注说明 -->
                  <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    

                    {{ $t("logs.Policy_list7") }} :
                  </div>
                  <div class="block block1">
                   <el-input
  placeholder="请输入内容"
  v-model="description"
  clearable>
</el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px"></div>
                  <div class="block block1">
                    <el-button type="primary" @click="save_ip()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="off_ip()">{{
                  $t("logs.save_b")
                }}</el-button>
                  </div>
                </div>
              </div>

            </div>
           
          </div>
        </el-tab-pane>
        <!-- 账号允许SMTP发信IP范围 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.smtpIp3") }}</span>
          <div class="main maina-a" v-show="this.system_ips_show==1">
            <p>
              <el-button
                @click="tan_ips()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.smtpIp8") }}</el-button
              >
              <el-alert
                :title="this.show_hint3"
                type="warning"
                show-icon
                :closable="false"
                style="width: auto"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-show="this.system_ips_show==1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList3"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column prop="EMAIL" :label="$t('logs.smtpIp9')">
                   <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.EMAIL"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_EMAIL }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="IPADDR" :label="$t('logs.network1_a5')">
                   <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.IPADDR"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_IPADDR }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>
                 <el-table-column prop="DESCRIPTION" :label="$t('logs.Policy_list7')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="del_ip(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                     <!-- 编辑 -->
                    <el-button
                      @click="edit_user_ips_smtp(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
             class="lie lie_add_role"
              v-show="tanchu"
            
            >
              <!--  认证控制-->
            
             
               <div class="create_information" v-show="this.system_ips_edit==0">
                {{ $t("logs.smtpIp8") }}
              </div>
              <div class="create_information" v-show="this.system_ips_edit == 1">
                {{ $t("logs.smtpIp8_edit") }}
              </div>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.smtpIp9") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      style="margin: 10px 0"
                      :autosize="{ minRows: 6, maxRows:10 }"
                      placeholder="一行一个,也可以用逗号隔开"
                      v-model="email1"
                    >
                    </el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_ip1") }}:
                  </div>
                  <div class="block block1">
                       <el-input
                      type="textarea"
                      style="margin: 10px 0"
                      :autosize="{ minRows: 6, maxRows:10 }"
                      placeholder="一行一个,也可以用逗号隔开"
                      v-model="ipaddr1"
                    >
                    </el-input>
                   
                  </div>
                </div>
                  <!-- 备注说明 -->
                  <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    

                    {{ $t("logs.Policy_list7") }} :
                  </div>
                  <div class="block block1">
                   <el-input
  placeholder="请输入内容"
  v-model="description"
  clearable>
</el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                  
                  </div>
                  <div class="block block1">
                   <el-button type="primary" @click="save_ips()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="off_ips()">{{
                  $t("logs.save_b")
                }}</el-button>
                  </div>
                </div>
              </div>

              <el-row>
               
              </el-row>
            </div>
           
          </div>
        </el-tab-pane>
          <!--  SMTP免认证IP范围 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.smtpIp4_four") }}</span>
          <div class="main maina-a" v-show="this.system_ips_show==1">
            <p>
              <el-button
                @click="tan_ips()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.smtpIp4_four_add") }}</el-button
              >
              <el-alert
                :title="this.show_hint4"
                type="warning"
                show-icon
                :closable="false"
                style="width: auto"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table" v-show="this.system_ips_show==1">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList4"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <!-- <el-table-column prop="EMAIL" :label="$t('logs.smtpIp9')">
                   <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.EMAIL"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_EMAIL }}</span>
                </el-tooltip>
                  </template>
                </el-table-column> -->
                <el-table-column prop="IPADDR" :label="$t('logs.network1_a5')">
                   <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.IPADDR"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_IPADDR }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>
                 <el-table-column prop="DESCRIPTION" :label="$t('logs.Policy_list7')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="del_ips_free(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                     <!-- 编辑 -->
                    <el-button
                      @click="edit_user_ips_smtp_free(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
             class="lie lie_add_role"
              v-show="tanchu"
            
            >
              <!--  认证控制-->
            
             
               <div class="create_information" v-show="this.system_ips_edit==0">
                {{ $t("logs.smtpIp4_four_add") }}
              </div>
              <div class="create_information" v-show="this.system_ips_edit == 1">
                {{ $t("logs.smtpIp4_four_edit") }}
              </div>
              <div class="find">
                <!-- <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.smtpIp9") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      style="margin: 10px 0"
                      :autosize="{ minRows: 6, maxRows:10 }"
                      placeholder="一行一个,也可以用逗号隔开"
                      v-model="email1"
                    >
                    </el-input>
                  </div>
                </div> -->
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_ip1") }}:
                  </div>
                  <div class="block block1">
                       <el-input
                      type="textarea"
                      style="margin: 10px 0"
                      :autosize="{ minRows: 6, maxRows:10 }"
                      placeholder="一行一个,也可以用逗号隔开"
                      v-model="ipaddr1"
                    >
                    </el-input>
                   
                  </div>
                </div>
                  <!-- 备注说明 -->
                  <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    

                    {{ $t("logs.Policy_list7") }} :
                  </div>
                  <div class="block block1">
                   <el-input
  placeholder="请输入内容"
  v-model="description"
  clearable>
</el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                  
                  </div>
                  <div class="block block1">
                   <el-button type="primary" @click="save_ips_free()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="off_ips()">{{
                  $t("logs.save_b")
                }}</el-button>
                  </div>
                </div>
              </div>

              <el-row>
               
              </el-row>
            </div>
           
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      defaut_pol: "",
      defaut_pol_arr: [],
      tanchu_edit: false,
      ipaddr: "",
      ipaddr1: "",
      type: 0,
      description:'',
      type_arr: [],
      email: "",
      email1: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      radio: [],
      show_hint1: "",
      show_hint2: "",
      show_hint3: "",
      show_hint4: "",
      control_edit: 0,
      control_show: 1,
      system_ip_edit:0,
      system_ip_show:1,
      system_ips_edit:0,
      system_ips_show:1,
      newadd: 1,
      newadd_id:'',
    };
  },
  mounted() {
    this.getFileList1();
    this.getFileList2();
    this.getFileList3();
    this.getFileList4();
  },
  methods: {
      dianji(value){
            console.log(value.index)
            this.control_show=1
            this.system_ip_show=1
            this.system_ips_show=1
            this.tanchu=false
      },
        del_ips_free(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_noneed_auth_ip",
            sid: sid,

            id: row.ID,
          });
          this.$axios.post("/api/adm/cgi/bspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList4();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
      save_ips_free() {
        this.$save_hint_test();
        this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let str = this.$qs.stringify({
        __mode: "save_noneed_auth_ip",
        sid: sid,
       
        ipaddr: this.ipaddr1,
        id:this.newadd_id,
        description:this.description,
      });
      this.$axios.post("/api/adm/cgi/bspam.cgi", str).then((res) => {
        // console.log(res);
   this.$close_hint_test();
   this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
  this.system_ips_show=1
          this.getFileList4();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    del_ips(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_permit_autheip",
            sid: sid,

            id: row.ID,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList3();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    save_ips() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let str = this.$qs.stringify({
        __mode: "save_permit_autheip",
        sid: sid,
        email: this.email1,
        ipaddr: this.ipaddr1,
        id:this.newadd_id,
        description:this.description,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
  this.system_ips_show=1
          this.getFileList3();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    del_ip(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_permit_authip",
            sid: sid,
            id:row.ID,
            permit_authip: row.ORGIP,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList2();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    save_ip() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let str = this.$qs.stringify({
        __mode: "save_permit_authip",
        sid: sid,
        newadd:this.newadd,
        ipaddr: this.ipaddr,
        id:this.newadd_id,
        description:this.description,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
        this.system_ip_show=1
          this.getFileList2();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    del_edit_user_smtp(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_authemail",
            sid: sid,

            id: row.ID,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    add_edit_user_smtp(index, row) {
      console.log(index, row);
      this.email = row.EMAIL;
      this.type = row.VALUE;
 this.newadd_id=row.ID
  this.description=row.DESCRIPTION
      this.tanchu = true;
      this.control_show = 0;
      this.control_edit = 1;
      this.newadd=0
    },
    off_edit_user_smtp() {
      this.tanchu_edit = false;
    },
    add_save_user_smtp() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "save_authemail",
            sid: sid,
            type: this.type,
            email: this.email,
            id: this.newadd_id,
            description:this.description,
          },
        })
        .then((res) => {
          console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;
            this.control_show=1
            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    off_save_user_smtp() {
      this.tanchu = false;
      this.control_show = 1;
    },
    // x系统默认军管控
    add_user_smtp() {
      this.tanchu = true;
      this.control_edit = 0;
      this.control_show = 0;
      this.newadd = 1;
      this.email = "";
       this.newadd_id=''
       this.description=''
    },
    tan_ip() {
      this.tanchu = true;
      this.system_ip_edit=0
      this.system_ip_show=0
      this.newadd=1
       this.newadd_id=''
      this.ipaddr = "";
      this.description=''
    },
    edit_user_smtp_ip(index, row) {
      console.log(index, row);
      this.ipaddr=row.IPADDR
       this.description=row.DESCRIPTION
      this.system_ip_show=0
      this.system_ip_edit=1
      this.newadd=0
       this.newadd_id=row.ID

      this.tanchu = true;
    },
    off_ip() {
      this.tanchu = false;
       this.system_ip_edit=1
      this.system_ip_show=1
    },
    tan_ips() {
      this.tanchu = true;
        this.system_ips_edit=0
      this.system_ips_show=0
      this.newadd=1
       this.newadd_id=''
      this.ipaddr1 = "";
      this.email1 = "";
      this.description=''
    },
    off_ips() {
      this.tanchu = false;
          this.system_ips_edit=1
      this.system_ips_show=1
    },
       edit_user_ips_smtp_free(index, row) {
      console.log(index, row);
      this.ipaddr1=row.IPADDR
      this.email1=row.EMAIL
      this.description=row.DESCRIPTION
      this.system_ips_show=0
      this.system_ips_edit=1
      this.newadd=0
      this.newadd_id=row.ID

      this.tanchu = true;
    },
     edit_user_ips_smtp(index, row) {
      console.log(index, row);
      this.ipaddr1=row.IPADDR
      this.email1=row.EMAIL
      this.description=row.DESCRIPTION
      this.system_ips_show=0
      this.system_ips_edit=1
      this.newadd=0
      this.newadd_id=row.ID

      this.tanchu = true;
    },
    save_user_smtp() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "save_smtp_auth_dft_pol",
            sid: sid,
            defaut_pol: this.defaut_pol,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 过滤单元加载
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_permitautheip",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList3 = res.data.ret.datalist;

            this.show_hint3 = res.data.ret.LOAD_HINT;
          }
        });
    },
      // 过滤单元加载
    getFileList4() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/bspam.cgi", {
          params: {
            __mode: "load_noneed_auth_ip",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList4 = res.data.ret.datalist;

            this.show_hint4 = res.data.ret.LOAD_HINT;
          }
        });
    },
    // 过滤单元加载
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_permitauthip",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList2 = res.data.ret.datalist;

            this.show_hint2 = res.data.ret.LOAD_HINT;
          }
        });
    },
    // 过滤单元加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "list_authemail",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList1 = res.data.ret.datalist;
            this.defaut_pol_arr = res.data.ret.q_type;
            this.type_arr = res.data.ret.q_add_type;
            this.defaut_pol = res.data.ret.DFT_SMTP_AUTHIP;
            this.show_hint1 = res.data.ret.LOAD_HINT2;
          }
        });
    },
    // 显示
    tan: function () {
      this.tanchu = true;
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
    },
    tanOff: function () {
      this.tanchu = false;
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 1
.main {
  display: flex;
  align-items: center;
  // border: 1px solid #dcdfe6;

  border: 2px solid #d2d7e6;
  // background: #f1f1f1;
  margin: 0 10px;

  text-align: left;
  margin-top: 10px;
}

.main p {
  height: 44px;
  width: 100%;
  display: flex;
  padding-left: 10px;
  font-size: 12px;

  align-items: center;
}

.main_text {
  margin-right: 6px;

  color: #0e2c5e;
}

.main .el-input {
  margin-right: 6px;
}

.main .el-select {
  margin-right: 6px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
@import "../../css/lie_add_role.less";

.maina-a {
  /deep/ .el-alert {
    line-height: 0px;
  }

  /deep/.el-alert__title {
    line-height: 14px;
  }
}
</style>
